import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Subscription } from "rxjs";
import { environment } from "src/environments/environment";

import { Link } from "../default-layout.page";
import { Store } from "@ngrx/store";
import { selectEmployeeBenefitsEasylinkPipeline } from "src/app/core/ngrx/ui/ui.selectors";
import {
  EasyLinkAttemptData,
  EmployeeBenefitsEasylinkPipeline,
  setEmployeeBenefitsEasylinkPipeline,
} from "src/app/core/ngrx/ui";
import { selectAccountInfo } from "src/app/core/ngrx/myqq";
import { filterSuccessMapToRightValue } from "src/lib/datum-either";
import { SnippetService } from "src/app/shared/services/snippet.service";

@Component({
  selector: "myqq-desktop-layout",
  templateUrl: "./desktop-layout.component.html",
  styleUrls: ["./desktop-layout.component.scss"],
  standalone: false,
})
export class DesktopLayoutComponent implements OnInit, OnDestroy {
  @Input() homeLink: Link[];
  @Input() accountLinks: Link[];
  @Input() referralLink?: Link;
  @Input() accountLinked: BehaviorSubject<boolean>;
  @Input() authenticated: boolean;

  @Output() authenticate: EventEmitter<boolean> = new EventEmitter();
  @Output() register: EventEmitter<void> = new EventEmitter(null);
  subs = [] as Subscription[];
  employeeBenefitsData: EmployeeBenefitsEasylinkPipeline;
  hasMembership = false;

  accountClicked = false;
  cdnHost = environment.cdnHost;
  employeeBenefitsEasylinkData$ = this.store$.select(
    selectEmployeeBenefitsEasylinkPipeline
  );

  constructor(
    readonly router: Router,
    readonly store$: Store<any>,
    private snippetService: SnippetService
  ) {}
  ngOnInit() {
    this.subs.push(
      this.employeeBenefitsEasylinkData$.subscribe((data) => {
        this.employeeBenefitsData = data;
      }),
      this.store$
        .select(selectAccountInfo)
        .pipe(filterSuccessMapToRightValue)
        .subscribe((resp) => {
          this.hasMembership = resp.subscription ? true : false;
          this.hasMembership &&
            !this.snippetService.getIsFriendbuyRibbonWidgetInitialized() &&
            this.snippetService.addFriendbuyRibbonWidget();
        })
    );
  }

  get isShowingAccountPage() {
    return this.router.url.match("/account");
  }

  get isShowingPurchasePage() {
    return this.router.url.match("/purchase");
  }

  handleAuthentication(loggedIn): void {
    this.authenticate.emit(loggedIn);
  }

  handleRegister() {
    this.register.emit();
  }

  flipArrow() {
    this.accountClicked = !this.accountClicked;
  }

  clearEasylinkData() {
    const easyLinkAttemptData: EasyLinkAttemptData = {
      showLinkAttemptData: false,
      isLinkingSuccess: this.employeeBenefitsData.linkAttemptData
        .isLinkingSuccess,
    };
    this.store$.dispatch(
      setEmployeeBenefitsEasylinkPipeline({
        ...this.employeeBenefitsData,
        linkAttemptData: easyLinkAttemptData,
      })
    );
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => sub.unsubscribe());
    if (
      this.isShowingPurchasePage &&
      this.employeeBenefitsData.linkAttemptData.showLinkAttemptData
    )
      this.clearEasylinkData();
  }
}
